import { cartQuery } from '@app/helpers/graphql/shopify/queries/cart';

export const createCartMutation = () => `
cartCreate(input: $cartInput) {
    ${cartQuery}
}
`;
